import { Link } from "react-router-dom";

import { useT } from "@/core/i18n";

export function LegalFooter() {
  const t = useT();
  return <footer className="legal-footer">
    <Link to="/legal/platform.terms">{t("legal.terms")}</Link>
    <Link to="/legal/platform.privacy">{t("legal.privacy")}</Link>
    <Link to="/legal/platform.impressum">{t("legal.impressum")}</Link>
    <Link to="/legal/payment_policy_platform">{t("legal.paymentPolicy")}</Link>
    <Link to="/legal">{t("legal.library")}</Link>
  </footer>;
}
